import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay, Pagination } from 'swiper/modules';
import { ToastContainer, toast } from 'react-toastify';
import { bannerAPI, newsAPI, videoAPI, adsAPI, imagaeAPI, YouTubevideoAPI, BengaluruNewsAPI, KarnatakaNewsAPI, NationalNewsAPI, YouTubevideoMetroAPI } from '../../services/api';
import Header from './Header';
import Footer from './Footer';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';

// Swiper CSS
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

// React Toastify CSS
import 'react-toastify/dist/ReactToastify.css';

// ---------- Main Homepage Component ----------
const NewsDetails = () => {

    // State
    const [loading, setLoading] = useState(false);
    const [banners, setBanners] = useState([]);
    const [allNews, setAllNews] = useState([]);
    const [videos, setVideos] = useState([]);
    const [ads, setAds] = useState([]);
    const [temperature, setTemperature] = useState('Loading...');
    const [youtubevideos, setYouTubeVideos] = useState([]);
    const [youtubevideosmetro, setYouTubeVideosMetro] = useState([]);
    const [error, setError] = useState(null);

    const [bengaluruallNews, setBengaluruAllNews] = useState([]);
    const [karnatakaallNews, setKarnatakaAllNews] = useState([]);
    const [nationalallNews, setNationalAllNews] = useState([]);


    const location = useLocation();
    const navigate = useNavigate();
    const news = location.state?.news;



    // Determine which fields exist (RSS vs internal)
    const title = news.title || news.news_title || 'Untitled';
    const image = news.image || news.photo || 'assets/img/blog/noimage.jpg';
    const date = news.pubDate || news.created_at;
    const description = news.description || news.content || 'No description available.';
    const originalLink = news.link || null;   // for RSS feeds


    const formattedDate = date
        ? new Date(date).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' })
        : 'Date not available';



    const fetchAds = async () => {
        setLoading(true);
        try {
            const res = await adsAPI.getAll();
            setAds(res.data.data);
        } catch (error) {
            console.error("Error fetching ads:", error);
        }
        finally {
            setLoading(false);
        }
    };





    const getAds = () =>
        ads.filter(n => n.status === 'active');



    useEffect(() => {

        fetchAds();


        fetch('https://wttr.in/Bengaluru?format=j1')
            .then(res => res.json())
            .then(data => {
                setTemperature(data.current_condition[0].temp_C + '°C');
            })
            .catch(() => setTemperature('N/A'));

    }, []);


    if (loading) {
        return (
            <div className="main-content" style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }



    // ---------- Render ----------
    return (
        <>
            <ToastContainer position="top-right" autoClose={3000} />

            <Header temperature={temperature} />


            {/* ===== MAIN CONTENT ===== */}
            <main>
                {/* breadcrumb-section */}
                <section className="breadcrumb-section__area">
                    <div className="container">
                        <div className="breadcrumb-section__content">
                            <h2 className="breadcrumb-section__title">{title}</h2>
                            <ul className="breadcrumb-section__list">
                                <li><Link to="/"><i className="fa-regular fa-house" /> Home</Link></li>

                            </ul>
                        </div>
                    </div>
                </section>
                {/* news-details */}
                <section className="news-details__area grey-bg section-space">
                    <div className="container">
                        <div className="row mb-minus-20">
                            <div className="col-lg-8">
                                <div className="blog-details__wrapper">
                                    <div className="blog-details__card">
                                        {image && (
                                            <div className="blog-details__thumb">
                                                <img src={image} alt={title} className="img-fluid" />
                                            </div>
                                        )}
                                        <div
                                            className="blog-details__content wow fadeInUp"
                                            data-wow-duration="0.7s"
                                            data-wow-delay="0.2s"
                                        >
                                            <div className="blog-details__meta" style={{ marginBottom: '1.5rem' }}>
                                                <span className="date">
                                                    <i className="fa-regular fa-calendar" /> {formattedDate}
                                                </span>

                                            </div>

                                            <div className="quill-readonly">
                                                <ReactQuill
                                                    theme="snow"
                                                    value={description}
                                                    readOnly={true}
                                                    modules={{ toolbar: false }}
                                                />
                                            </div>

                                        </div>


                                    </div>



                                </div>
                            </div>
                            <div className="col-lg-4">
                                <div className="blog-sidebar__wrapper">



                                    <div
                                        className="blog-sidebar__wrap mb-20 wow fadeInUp"
                                        data-wow-duration="0.7s"
                                        data-wow-delay="0.2s"
                                    >
                                        <h3 className="blog-sidebar__title">Advertisement</h3>
                                        <div className="blog-sidebar__gallery blog-sidebar__gallery-2">


                                            {ads.length > 0 && (

                                                <>


                                                    {ads.map((ad) => (

                                                        <div className="" key={ad.id}>

                                                            <img src={`${imagaeAPI}/uploads/ads/${ad.ads_photo}`} alt={ad.ads_title} />

                                                        </div>

                                                    ))
                                                    }

                                                </>

                                            )}



                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>


            {/* ===== FOOTER ===== */}

            < Footer />

        </>
    );
};

// ---------- SUBCOMPONENTS ----------



export default NewsDetails;